var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useMemo, useState } from 'react';
import { Button, Card, DatePicker, Drawer, Form, Image, Input, Modal, Select, Space, Table, Tag, Typography, message } from 'antd';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { approveStiDocumentSubmission, fetchStiDocumentSubmission, fetchStiDocumentSubmissions, rejectStiDocumentSubmission } from '../cores/api/api-dashboard';
import { STI_DOCUMENT_QUERY_KEY, STI_STATUS_COLOR_MAP, STI_STATUS_FILTER_OPTIONS, STI_STATUS_LABEL_MAP } from '../contants/option';
dayjs.extend(utc);
dayjs.extend(timezone);
const JAPAN_TIMEZONE = 'Asia/Tokyo';
const Link = Typography.Link, Text = Typography.Text;
const TextArea = Input.TextArea;
const formatDatetime = (value, fallback = '-') => {
    if (!value)
        return fallback;
    return dayjs(value).tz(JAPAN_TIMEZONE).format('YYYY-MM-DD HH:mm');
};
const formatDate = (value, fallback = '-') => {
    if (!value)
        return fallback;
    return dayjs(value).format('YYYY-MM-DD');
};
const readInitialFilters = () => {
    const params = new URLSearchParams(window.location.search);
    const userId = params.get('user_id');
    const status = params.get('status');
    return {
        userId: userId && /^\d+$/.test(userId) ? userId : undefined,
        status: status || 'pending'
    };
};
export default function StiDocumentsPage({ embedded = false }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const initial = useMemo(() => readInitialFilters(), []);
    const _Form$useForm = Form.useForm(), _Form$useForm2 = _slicedToArray(_Form$useForm, 1), filterForm = _Form$useForm2[0];
    const _message$useMessage = message.useMessage(), _message$useMessage2 = _slicedToArray(_message$useMessage, 2), messageApi = _message$useMessage2[0], contextHolder = _message$useMessage2[1];
    const queryClient = useQueryClient();
    const _useState = useState(initial.status), _useState2 = _slicedToArray(_useState, 2), statusFilter = _useState2[0], setStatusFilter = _useState2[1];
    const _useState3 = useState(''), _useState4 = _slicedToArray(_useState3, 2), searchQuery = _useState4[0], setSearchQuery = _useState4[1];
    const _useState5 = useState(initial.userId), _useState6 = _slicedToArray(_useState5, 2), userIdFilter = _useState6[0], setUserIdFilter = _useState6[1];
    const _useState7 = useState(1), _useState8 = _slicedToArray(_useState7, 2), page = _useState8[0], setPage = _useState8[1];
    const _useState9 = useState(20), _useState0 = _slicedToArray(_useState9, 2), perPage = _useState0[0], setPerPage = _useState0[1];
    const _useState1 = useState(false), _useState10 = _slicedToArray(_useState1, 2), detailOpen = _useState10[0], setDetailOpen = _useState10[1];
    const _useState11 = useState(null), _useState12 = _slicedToArray(_useState11, 2), selectedId = _useState12[0], setSelectedId = _useState12[1];
    // Bump on every 詳細 click so signed image URLs are re-fetched (TTL can expire while admin works).
    const _useState13 = useState(0), _useState14 = _slicedToArray(_useState13, 2), detailFetchNonce = _useState14[0], setDetailFetchNonce = _useState14[1];
    const _useState15 = useState(false), _useState16 = _slicedToArray(_useState15, 2), approveOpen = _useState16[0], setApproveOpen = _useState16[1];
    const _useState17 = useState(false), _useState18 = _slicedToArray(_useState17, 2), rejectOpen = _useState18[0], setRejectOpen = _useState18[1];
    const _Form$useForm3 = Form.useForm(), _Form$useForm4 = _slicedToArray(_Form$useForm3, 1), approveForm = _Form$useForm4[0];
    const _Form$useForm5 = Form.useForm(), _Form$useForm6 = _slicedToArray(_Form$useForm5, 1), rejectForm = _Form$useForm6[0];
    const apiFilters = useMemo(() => _objectSpread(_objectSpread({
        page,
        per_page: perPage,
        status: statusFilter
    }, searchQuery.trim() ? {
        q: searchQuery.trim()
    } : {}), userIdFilter ? {
        user_id: userIdFilter
    } : {}), [page, perPage, searchQuery, statusFilter, userIdFilter]);
    const listQueryKey = [...STI_DOCUMENT_QUERY_KEY, apiFilters];
    const _useQuery = useQuery({
        queryKey: listQueryKey,
        queryFn: () => fetchStiDocumentSubmissions(apiFilters)
    }), data = _useQuery.data, isLoading = _useQuery.isLoading, refetch = _useQuery.refetch;
    const _useQuery2 = useQuery({
        queryKey: [...STI_DOCUMENT_QUERY_KEY, 'detail', selectedId, detailFetchNonce],
        queryFn: () => fetchStiDocumentSubmission(selectedId),
        enabled: detailOpen && selectedId != null,
        staleTime: 0,
        refetchOnMount: 'always'
    }), detailData = _useQuery2.data, detailLoading = _useQuery2.isLoading, detailFetching = _useQuery2.isFetching;
    const detail = detailData === null || detailData === void 0 ? void 0 : detailData.data;
    const canReview = (detail === null || detail === void 0 ? void 0 : detail.status) === 'pending';
    const detailBusy = detailLoading || detailFetching;
    const approveMutation = useMutation({
        mutationFn: ({ id, expiresAt }) => approveStiDocumentSubmission(id, expiresAt),
        onSuccess: (response) => __awaiter(this, void 0, void 0, function* () {
            if (!response.success) {
                throw new Error(response.error || 'Approve failed');
            }
            yield queryClient.invalidateQueries({
                queryKey: STI_DOCUMENT_QUERY_KEY
            });
            messageApi.success(response.message || '承認しました');
            setApproveOpen(false);
            approveForm.resetFields();
        }),
        onError: error => {
            messageApi.error(error.message);
        }
    });
    const rejectMutation = useMutation({
        mutationFn: ({ id, reason }) => rejectStiDocumentSubmission(id, reason),
        onSuccess: (response) => __awaiter(this, void 0, void 0, function* () {
            if (!response.success) {
                throw new Error(response.error || 'Reject failed');
            }
            yield queryClient.invalidateQueries({
                queryKey: STI_DOCUMENT_QUERY_KEY
            });
            messageApi.success(response.message || '却下しました');
            setRejectOpen(false);
            rejectForm.resetFields();
        }),
        onError: error => {
            messageApi.error(error.message);
        }
    });
    const openDetail = record => {
        queryClient.removeQueries({
            queryKey: [...STI_DOCUMENT_QUERY_KEY, 'detail', record.id]
        });
        setSelectedId(record.id);
        setDetailFetchNonce(n => n + 1);
        setDetailOpen(true);
    };
    const closeDetail = () => {
        setDetailOpen(false);
        setSelectedId(null);
        setApproveOpen(false);
        setRejectOpen(false);
    };
    const handleFilter = values => {
        var _a, _b;
        setSearchQuery(((_a = values.q) === null || _a === void 0 ? void 0 : _a.trim()) || '');
        setStatusFilter(values.status || 'pending');
        setUserIdFilter(((_b = values.user_id) === null || _b === void 0 ? void 0 : _b.trim()) || undefined);
        setPage(1);
    };
    const handleResetFilter = () => {
        filterForm.resetFields();
        setSearchQuery('');
        setStatusFilter('pending');
        setUserIdFilter(undefined);
        setPage(1);
    };
    const handleTableChange = pagination => {
        var _a, _b;
        setPage((_a = pagination.current) !== null && _a !== void 0 ? _a : 1);
        setPerPage((_b = pagination.pageSize) !== null && _b !== void 0 ? _b : 20);
    };
    const submitApprove = () => __awaiter(this, void 0, void 0, function* () {
        if (!selectedId)
            return;
        const values = yield approveForm.validateFields();
        yield approveMutation.mutateAsync({
            id: selectedId,
            expiresAt: values.expires_at.format('YYYY-MM-DD')
        });
    });
    const submitReject = () => __awaiter(this, void 0, void 0, function* () {
        if (!selectedId)
            return;
        const values = yield rejectForm.validateFields();
        yield rejectMutation.mutateAsync({
            id: selectedId,
            reason: values.rejection_reason.trim()
        });
    });
    const columns = [{
            title: 'ID',
            dataIndex: 'id',
            width: 72
        }, {
            title: 'ユーザー',
            width: 220,
            render: (_, record) => /*#__PURE__*/ React.createElement("div", {
                className: "flex flex-col gap-1 text-[12px]"
            }, /*#__PURE__*/ React.createElement(Link, {
                href: `/userpage?id=${record.user_id}`,
                target: "_blank"
            }, "#", record.user_id, " ", record.twitter_name || record.user_email || '-'), record.user_email && record.twitter_name ? /*#__PURE__*/ React.createElement(Text, {
                type: "secondary"
            }, record.user_email) : null)
        }, {
            title: '枚数',
            dataIndex: 'image_count',
            width: 64
        }, {
            title: 'ステータス',
            dataIndex: 'status',
            width: 110,
            render: status => /*#__PURE__*/ React.createElement(Tag, {
                color: STI_STATUS_COLOR_MAP[status] || 'default'
            }, STI_STATUS_LABEL_MAP[status] || status)
        }, {
            title: '提出日時',
            dataIndex: 'uploaded_at',
            width: 150,
            render: value => formatDatetime(value)
        }, {
            title: '有効期限',
            dataIndex: 'expires_at',
            width: 110,
            render: value => formatDate(value)
        }, {
            title: '操作',
            width: 100,
            render: (_, record) => /*#__PURE__*/ React.createElement(Button, {
                type: "link",
                size: "small",
                onClick: () => openDetail(record)
            }, "\u8A73\u7D30")
        }];
    const renderImageGallery = images => {
        if (!(images === null || images === void 0 ? void 0 : images.length)) {
            return /*#__PURE__*/ React.createElement(Text, {
                type: "secondary"
            }, "\u753B\u50CF\u304C\u3042\u308A\u307E\u305B\u3093");
        }
        return /*#__PURE__*/ React.createElement(Image.PreviewGroup, null, /*#__PURE__*/ React.createElement("div", {
            className: "grid grid-cols-2 gap-3 md:grid-cols-3"
        }, images.map(img => /*#__PURE__*/ React.createElement("div", {
            key: img.id,
            className: "h-[160px] w-full overflow-hidden rounded border border-[#e5e7eb]"
        }, img.image_url ? /*#__PURE__*/ React.createElement(Image, {
            src: img.image_url,
            alt: `sti-${img.id}`,
            width: "100%",
            height: 160,
            referrerPolicy: "no-referrer",
            style: {
                width: '100%',
                height: 160,
                objectFit: 'cover',
                objectPosition: 'center',
                display: 'block'
            },
            rootClassName: "!block !h-full !w-full"
        }) : /*#__PURE__*/ React.createElement("div", {
            className: "flex h-full items-center justify-center text-[12px] text-[#6b7280]"
        }, "\u753B\u50CFURL\u3092\u53D6\u5F97\u3067\u304D\u307E\u305B\u3093")))));
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: embedded ? '' : 'min-h-screen bg-[#f5f5f5] px-6 py-6'
    }, contextHolder, /*#__PURE__*/ React.createElement("div", {
        className: embedded ? '' : 'mx-auto max-w-[1680px]'
    }, !embedded && /*#__PURE__*/ React.createElement("div", {
        className: "mb-4 text-[24px] font-semibold text-[#111827]"
    }, "\u6027\u75C5\u691C\u67FB\u5BE9\u67FB"), /*#__PURE__*/ React.createElement(Card, {
        className: "mb-4"
    }, /*#__PURE__*/ React.createElement(Form, {
        form: filterForm,
        layout: "inline",
        initialValues: {
            status: initial.status,
            user_id: initial.userId
        },
        onFinish: handleFilter,
        className: "flex flex-wrap gap-y-3"
    }, /*#__PURE__*/ React.createElement(Form.Item, {
        name: "status",
        label: "\u30B9\u30C6\u30FC\u30BF\u30B9"
    }, /*#__PURE__*/ React.createElement(Select, {
        style: {
            width: 140
        },
        options: STI_STATUS_FILTER_OPTIONS
    })), /*#__PURE__*/ React.createElement(Form.Item, {
        name: "user_id",
        label: "User ID"
    }, /*#__PURE__*/ React.createElement(Input, {
        placeholder: "4908",
        style: {
            width: 120
        },
        allowClear: true
    })), /*#__PURE__*/ React.createElement(Form.Item, {
        name: "q",
        label: "\u691C\u7D22"
    }, /*#__PURE__*/ React.createElement(Input, {
        placeholder: "email / twitter_name",
        style: {
            width: 220
        },
        allowClear: true
    })), /*#__PURE__*/ React.createElement(Form.Item, null, /*#__PURE__*/ React.createElement(Space, null, /*#__PURE__*/ React.createElement(Button, {
        type: "primary",
        htmlType: "submit"
    }, "\u691C\u7D22"), /*#__PURE__*/ React.createElement(Button, {
        onClick: handleResetFilter
    }, "\u30EA\u30BB\u30C3\u30C8"), /*#__PURE__*/ React.createElement(Button, {
        onClick: () => refetch()
    }, "\u66F4\u65B0"))))), /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Table, {
        rowKey: "id",
        loading: isLoading,
        columns: columns,
        dataSource: (_a = data === null || data === void 0 ? void 0 : data.data) !== null && _a !== void 0 ? _a : [],
        pagination: {
            current: (_c = (_b = data === null || data === void 0 ? void 0 : data.meta) === null || _b === void 0 ? void 0 : _b.current_page) !== null && _c !== void 0 ? _c : page,
            pageSize: (_e = (_d = data === null || data === void 0 ? void 0 : data.meta) === null || _d === void 0 ? void 0 : _d.per_page) !== null && _e !== void 0 ? _e : perPage,
            total: (_g = (_f = data === null || data === void 0 ? void 0 : data.meta) === null || _f === void 0 ? void 0 : _f.total_count) !== null && _g !== void 0 ? _g : 0,
            showSizeChanger: true
        },
        onChange: handleTableChange
    }))), /*#__PURE__*/ React.createElement(Drawer, {
        title: `提出詳細 #${selectedId !== null && selectedId !== void 0 ? selectedId : ''}`,
        width: 720,
        open: detailOpen,
        onClose: closeDetail,
        destroyOnClose: true,
        extra: canReview ? /*#__PURE__*/ React.createElement(Space, null, /*#__PURE__*/ React.createElement(Button, {
            type: "primary",
            onClick: () => setApproveOpen(true)
        }, "\u627F\u8A8D"), /*#__PURE__*/ React.createElement(Button, {
            danger: true,
            onClick: () => setRejectOpen(true)
        }, "\u5374\u4E0B")) : null
    }, detailBusy && !detail ? /*#__PURE__*/ React.createElement("div", null, "Loading...") : detail ? /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col gap-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-2 gap-3 text-[13px]"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Text, {
        type: "secondary"
    }, "\u30E6\u30FC\u30B6\u30FC"), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Link, {
        href: `/userpage?id=${detail.user_id}`,
        target: "_blank"
    }, "#", detail.user_id), ((_h = detail.user) === null || _h === void 0 ? void 0 : _h.twitter_name) ? ` @${detail.user.twitter_name}` : ''), /*#__PURE__*/ React.createElement("div", null, ((_j = detail.user) === null || _j === void 0 ? void 0 : _j.email) || detail.user_email)), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Text, {
        type: "secondary"
    }, "\u30B9\u30C6\u30FC\u30BF\u30B9"), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Tag, {
        color: STI_STATUS_COLOR_MAP[detail.status]
    }, STI_STATUS_LABEL_MAP[detail.status]))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Text, {
        type: "secondary"
    }, "\u63D0\u51FA\u65E5\u6642"), /*#__PURE__*/ React.createElement("div", null, formatDatetime(detail.uploaded_at))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Text, {
        type: "secondary"
    }, "\u5BE9\u67FB\u65E5\u6642"), /*#__PURE__*/ React.createElement("div", null, formatDatetime(detail.reviewed_at))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Text, {
        type: "secondary"
    }, "\u6709\u52B9\u671F\u9650"), /*#__PURE__*/ React.createElement("div", null, formatDate(detail.expires_at))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Text, {
        type: "secondary"
    }, "\u753B\u50CF\u679A\u6570"), /*#__PURE__*/ React.createElement("div", null, detail.image_count))), detail.rejection_reason ? /*#__PURE__*/ React.createElement("div", {
        className: "rounded border border-red-200 bg-red-50 p-3 text-[13px]"
    }, /*#__PURE__*/ React.createElement(Text, {
        type: "danger"
    }, "\u5374\u4E0B\u7406\u7531"), /*#__PURE__*/ React.createElement("div", {
        className: "mt-1 whitespace-pre-wrap"
    }, detail.rejection_reason)) : null, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Text, {
        strong: true
    }, "\u63D0\u51FA\u753B\u50CF"), /*#__PURE__*/ React.createElement("div", {
        className: "mt-3"
    }, renderImageGallery(detail.images)))) : /*#__PURE__*/ React.createElement(Text, {
        type: "secondary"
    }, "\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093")), /*#__PURE__*/ React.createElement(Modal, {
        title: "\u627F\u8A8D \u2014 \u6709\u52B9\u671F\u9650\u3092\u5165\u529B",
        open: approveOpen,
        onCancel: () => setApproveOpen(false),
        onOk: submitApprove,
        confirmLoading: approveMutation.isPending,
        okText: "\u627F\u8A8D\u3059\u308B",
        cancelText: "\u30AD\u30E3\u30F3\u30BB\u30EB",
        destroyOnClose: true
    }, /*#__PURE__*/ React.createElement(Form, {
        form: approveForm,
        layout: "vertical",
        preserve: false
    }, /*#__PURE__*/ React.createElement(Form.Item, {
        name: "expires_at",
        label: "\u6709\u52B9\u671F\u9650 (expires_at)",
        rules: [{
                required: true,
                message: '有効期限を選択してください'
            }]
    }, /*#__PURE__*/ React.createElement(DatePicker, {
        className: "w-full",
        format: "YYYY-MM-DD"
    })))), /*#__PURE__*/ React.createElement(Modal, {
        title: "\u5374\u4E0B \u2014 \u7406\u7531\u3092\u5165\u529B",
        open: rejectOpen,
        onCancel: () => setRejectOpen(false),
        onOk: submitReject,
        confirmLoading: rejectMutation.isPending,
        okText: "\u5374\u4E0B\u3059\u308B",
        cancelText: "\u30AD\u30E3\u30F3\u30BB\u30EB",
        destroyOnClose: true
    }, /*#__PURE__*/ React.createElement(Form, {
        form: rejectForm,
        layout: "vertical",
        preserve: false
    }, /*#__PURE__*/ React.createElement(Form.Item, {
        name: "rejection_reason",
        label: "\u5374\u4E0B\u7406\u7531",
        rules: [{
                required: true,
                message: '却下理由を入力してください'
            }, {
                min: 10,
                message: '10文字以上入力してください'
            }, {
                max: 1000,
                message: '1000文字以内で入力してください'
            }]
    }, /*#__PURE__*/ React.createElement(TextArea, {
        rows: 4,
        placeholder: "\u753B\u50CF\u304C\u4E0D\u9BAE\u660E\u3067\u3059\u3002\u518D\u64AE\u5F71\u3057\u3066\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    })))));
}
